import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { cn } from 'src/utils/style'

export const LegalFooterLinks = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  return (
    <nav
      data-testid="legal-footer-links"
      className={cn(['flex justify-center gap-4 text-xs text-gray-500', className])}
    >
      <Link className="hover:underline" to="/legal/terms">
        {t('legal.termsLink')}
      </Link>
      <Link className="hover:underline" to="/legal/privacy">
        {t('legal.privacyLink')}
      </Link>
    </nav>
  )
}
